export default __webpack_public_path__ + "static/media/nonye.dccaee8f.png";